import { Component, inject, OnInit } from '@angular/core';
import { SupaStatisticsApi } from '../../data/supa-statistics/supa-statistics.api';
import { PopoverController } from '@ionic/angular';
import { SupaStatisticsDayPopoverComponent } from './supa-statistics-day-popover.component';
import { Router } from '@angular/router';
import { EntryRepository } from '../../data/entry/entry.repository';
import { map } from 'rxjs';
import { SupaStatisticsRepository } from '../../data/supa-statistics/supa-statistics.repository';

export interface StatisticDay {
  date: string;
  //entryCount: number;
  charCount: number;
}


@Component({
  selector: 'app-supa-statistics',
  templateUrl: './supa-statistics.component.html',
  styleUrls: ['./supa-statistics.component.scss']
})
export class SupaStatisticsComponent implements OnInit {
  private popoverController = inject(PopoverController);
  private router = inject(Router);
  private supaStatisticsApi = inject(SupaStatisticsApi);
  private statisticsRepository = inject(SupaStatisticsRepository);
  private entryRepository = inject(EntryRepository);

  currentStreak$ = this.statisticsRepository.currentStreak$;
  highestStreak$ = this.statisticsRepository.streaks$.pipe(map(streaks => {
    let highestStreak = 0;
    let highestStreakIndex = 0;
    streaks.forEach((streak, index) => {
      if (streak.days_count > highestStreak) {
        highestStreak = streak.days_count;
        highestStreakIndex = index;
      }
    });
    return streaks[highestStreakIndex];
  }))


  maxCharsOfDay = 0;

  constructor() {
    // this.createWeeksOfYearArray();
  }


  async ngOnInit() {

  }

  popover: HTMLIonPopoverElement | null = null;

  showDayInBlog(date: string) {
    this.router.navigate(['topics', 'day', date])
  }

  async mouseEntersDay(ev: MouseEvent, day: StatisticDay) {
    if (this.popover) {
      await this.popover.dismiss();
    }
    this.popover = await this.popoverController.create({
      event: ev,
      component: SupaStatisticsDayPopoverComponent,
      componentProps: {day},
      animated: false
    });
    await this.popover.present();
  }
}
